import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  API,
  GlobalActions,
  SidePanelContainer,
  SidePanelHeader,
  SidePanelContent,
  TableCompanyBanners,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';
import ImportZones from './ImportZones';

function CompanyBannersImport({
  companyId,
  mediaFormat,
  onClose,
  setPanel,
}) {
  /**
   * Close the panel
   */
  const onCloseBannerImport = () => {
    onClose();

    setPanel({
      show: false,
    });

    // Reset the children after it's been hidden
    setTimeout(() => {
      setPanel({
        children: null,
      });
    }, 900);
  };

  /**
   * Show the new/edit banner
   */
  const onOpenBanner = (banner = {}) => {
    setPanel({
      extraPanel: {
        title: banner._id
          ? 'Update Banner'
          : 'New Banner',
        width: window.innerWidth,
        show: true,
        children: (
          <ImportZones
            companyId={companyId}
            bannerId={banner._id}
            bannerName={banner.value}
            mediaFormat={mediaFormat}
            onClose={onCloseBannerImport}
          />
        ),
      },
    });
  };

  useEffect(() => {
    // tell listening components the object was saved
    document.dispatchEvent(new Event('onSaveCompanyBanner'));
  }, [companyId]);

  return (
    <SidePanelContainer className="CompanyBanners">
      <SidePanelHeader
        icons={(
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <VibeIcon
              className="close"
              icon={viClose}
              color={color.manatee}
              hoverColor={color.obsidian}
              size={24}
              onClick={onCloseBannerImport}
            />
          </div>
        )}
      >
        <div className="title">
          Banners
        </div>
      </SidePanelHeader>

      <SidePanelContent
        style={{
          display: 'flex',
          padding: 0,
        }}
      >
        <TableCompanyBanners
          columns={[
            'Banner',
            '...',
          ]}
          fetch={API.Company.Banner.list}
          fetchProps={{
            filters: {
              companyId,
            },
          }}
          defaultSortBy={{
            label: 'Banner',
            attr: 'value',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Banners',
            urlPaging: false,
            urlFilters: false,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Banners',
            tooltip: true,
          }}
          menuItems={[
            { name: 'Archive', userCan: 'company_banner.delete' },
          ]}
          companyId={companyId}
          onClickRow={onOpenBanner}
        />
      </SidePanelContent>
    </SidePanelContainer>
  );
}

CompanyBannersImport.propTypes = {
  companyId: PropTypes.string,
  onClose: PropTypes.func,
};

CompanyBannersImport.defaultProps = {
  companyId: '',
  onClose: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyBannersImport);
